"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLiveClassByIds = void 0;
const tslib_1 = require("tslib");
const groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
const uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
const __enums_1 = require("../../__types/__enums");
const liveClassEventsHelpers_1 = require("./common/liveClassEventsHelpers");
const liveClassHelpers_1 = require("./common/liveClassHelpers");
function attachLiveClassEvents(liveClasses) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const liveClassIds = liveClasses.map(liveClass => liveClass.id);
        const filters = [
            { name: __enums_1.LiveClassIdFilterEnum.CLASS_ID, type: __enums_1.ElasticsearchFilterTypeEnum.MUST, values: liveClassIds }
        ];
        const liveClassEvents = yield liveClassEventsHelpers_1.loadLiveClassEventsFromLiveClassIds(filters);
        const liveClassEventsByClassId = groupBy_1.default(liveClassEvents, 'classId');
        liveClasses.forEach(liveClass => {
            const { id } = liveClass;
            liveClass.events = liveClassEventsByClassId[id];
        });
    });
}
function getLiveClassByIds(filters) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let liveClassIds = filters[0].values;
        liveClassIds = uniq_1.default(liveClassIds);
        const liveClasses = yield liveClassHelpers_1.loadLiveClassFromLiveClassIds(filters);
        yield attachLiveClassEvents(liveClasses);
        return { liveClasses, total: liveClasses.length };
    });
}
exports.getLiveClassByIds = getLiveClassByIds;
//# sourceMappingURL=getLiveClassByIds.js.map